// import { getDate } from "date-fns";

const locale = 'sv-SE';

const getDateString = (date, type = 'long', time = false) => {

  let dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };

  if (type === 'short') {
    dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
  }

  let dateString = date.toLocaleDateString(locale, dateOptions);

  if (time) {
    const timeOptions = { hour: '2-digit', minute: '2-digit' };
    dateString += " kl " + date.toLocaleTimeString(locale, timeOptions);
  }

  return dateString;

};

export default getDateString;

